<div class="detail-header" mat-dialog-title>
    <h3>Requêtes de {{title}}</h3>
    <div class="detail-filters">
        <mat-form-field class="filter" subscriptSizing="dynamic">
            <mat-label>Action</mat-label>
            <mat-select [(ngModel)]="actionFilter" (selectionChange)="onFilterChange()">
                <mat-option [value]="undefined">Toutes</mat-option>
                @for (action of actionOptions; track action.value) {
                    <mat-option [value]="action.value">{{action.label}}</mat-option>
                }
            </mat-select>
        </mat-form-field>
        <mat-form-field class="filter" subscriptSizing="dynamic">
            <mat-label>Statut</mat-label>
            <mat-select [(ngModel)]="statusFilter" (selectionChange)="onFilterChange()">
                <mat-option [value]="undefined">Tous</mat-option>
                <mat-option value="OK">OK</mat-option>
                <mat-option value="KO">KO</mat-option>
            </mat-select>
        </mat-form-field>
        <button mat-icon-button mat-dialog-close aria-label="Fermer">
            <mat-icon>close</mat-icon>
        </button>
    </div>
</div>

<mat-dialog-content class="lines-content">
    <div class="table-wrapper">
        <table mat-table [dataSource]="lines" class="pulpo-table w-100" matSort
            [matSortActive]="sort.active" [matSortDirection]="sort.direction"
            (matSortChange)="onSortChange($event)">
            <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
                <td mat-cell *matCellDef="let line">{{line.date | date: 'dd/MM/yy HH:mm'}}</td>
            </ng-container>
            <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Action</th>
                <td mat-cell *matCellDef="let line">{{actionLabel(line.action)}}</td>
            </ng-container>
            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Statut</th>
                <td mat-cell *matCellDef="let line">
                    <span [class.ko]="line.status === 'KO'" [matTooltip]="line.errorCode">{{line.status}}</span>
                </td>
            </ng-container>
            <ng-container matColumnDef="product">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Produit</th>
                <td mat-cell *matCellDef="let line">{{line.product}}</td>
            </ng-container>
            <ng-container matColumnDef="dates">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Départ / retour</th>
                <td mat-cell *matCellDef="let line">
                    {{line.dateBegin | date: 'dd/MM/yyyy'}}@if (line.dateEnd) {<span> → {{line.dateEnd | date: 'dd/MM/yyyy'}}</span>}
                </td>
            </ng-container>
            <ng-container matColumnDef="cities">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Villes</th>
                <td mat-cell *matCellDef="let line">
                    {{line.fromIata}}@if (line.toIata) {<span> → {{line.toIata}}</span>}
                </td>
            </ng-container>
            <ng-container matColumnDef="travellers">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Voyageurs</th>
                <td mat-cell *matCellDef="let line">{{line.travellers}}</td>
            </ng-container>
            <ng-container matColumnDef="bookingId">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Dossier</th>
                <td mat-cell *matCellDef="let line">{{line.bookingId}}</td>
            </ng-container>
            <ng-container matColumnDef="time">
                <th mat-header-cell *matHeaderCellDef class="count">Temps</th>
                <td mat-cell *matCellDef="let line" class="count">{{line.time ? line.time + ' s' : ''}}</td>
            </ng-container>
            <ng-container matColumnDef="payloads">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let line" class="payloads">
                    @if (line.request) {
                        <button mat-stroked-button (click)="showPayload(line.request)">Requête</button>
                    }
                    @if (line.response) {
                        <button mat-stroked-button (click)="showPayload(line.response)">Réponse</button>
                    }
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="columns; sticky: true"></tr>
            <tr mat-row *matRowDef="let line; columns: columns;"></tr>
            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell empty" [attr.colspan]="columns.length">
                    {{loading ? 'Chargement…' : 'Aucune requête'}}
                </td>
            </tr>
        </table>
    </div>
</mat-dialog-content>

<mat-dialog-actions>
    <mat-paginator class="w-100" [length]="totalLines" [pageSize]="pageSize" [pageIndex]="pageIndex"
        [hidePageSize]="true" (page)="onPage($event)" showFirstLastButtons></mat-paginator>
</mat-dialog-actions>
